import { Sidebar as PrimeSidebar } from "primereact/sidebar";
import React from "react";
import { Divider } from "primereact/divider";

import { ISidebarContainerProps } from "./type";

export function SidebarContainers(props: ISidebarContainerProps) {
  const { show, onClose, children, title } = props;

  return (
    <PrimeSidebar
      visible={show}
      position="right"
      onHide={onClose}
      className="p-sidebar-md"
      style={{ width: "40vw" }}
      title={title}
      header={<span className="text-xl font-bold">{title}</span>}
    >
      <Divider />
      <div>{children}</div>
    </PrimeSidebar>
  );
}
